export const BROKER_LOCATION_QUERY = {
  type: 'locType',
  code: 'locCode',
  name: 'locName',
  postcode: 'locPostcode',
} as const;
